import styled from "styled-components";

import { Td } from "./Table/Td";

export const AmountTD = styled(Td)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: ${props => props.textAlign || "right"};

    ${props => props.amount < 0 && "color: red !important;"}
`;
